export default __webpack_public_path__ + "static/hero-bg2-f0c55c194dca434b5e38ccd08c41af68.jpg";